import {
    GET_CLIENT_OVERVIEW_SUCCESS,
    GET_DOMAIN_PROGRESS_SUCCESS,
    GET_GOALS_PROGRESS_SUCCESS,
    GET_GOAL_DRILLDOWN_SUMMARY_SUCCESS,
    GET_GOAL_DRILLDOWN_TARGETS_SUCCESS,
    RESET_GOAL_DRILLDOWN,
    RESET_CLINICAL_ANALYTICS,
} from './clinicalAnalytics.types';

const initialState = {
    clientOverview: null,
    domainProgress: null,
    goalsProgress: [],
    goalDrilldown: null,
};

export const clinicalAnalyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CLIENT_OVERVIEW_SUCCESS:
            return {
                ...state,
                clientOverview: action.payload,
            };

        case GET_DOMAIN_PROGRESS_SUCCESS:
            return {
                ...state,
                domainProgress: action.payload,
            };

        case GET_GOALS_PROGRESS_SUCCESS:
            return {
                ...state,
                goalsProgress: action.payload,
            };

        case GET_GOAL_DRILLDOWN_SUMMARY_SUCCESS:
            return {
                ...state,
                goalDrilldown: {
                    ...(state.goalDrilldown || {}),
                    ...action.payload,
                },
            };

        case GET_GOAL_DRILLDOWN_TARGETS_SUCCESS:
            return {
                ...state,
                goalDrilldown: {
                    ...(state.goalDrilldown || {}),
                    goalId: action.payload?.goalId ?? state.goalDrilldown?.goalId,
                    targetProgress: action.payload?.targetProgress || [],
                },
            };

        case RESET_GOAL_DRILLDOWN:
            return {
                ...state,
                goalDrilldown: null,
            };

        case RESET_CLINICAL_ANALYTICS:
            return initialState;

        default:
            return state;
    }
};
